import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function DietDetail(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [viewdietinData, setViewDietinData] = useState([]);
  const [viewdietoutData, setViewDietoutData] = useState([]);
  const [dietinData,setdietinData]=useState({
        "ip":'',
        "blood":'',
        "bqty":'',
        "fluid":'',
        "fqty":'',
        "ngqty":'',
        "oral":'',
        "oqty":'',
        "in_time":'',
        "in_notes":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
    const [dietoutData,setdietoutData]=useState({
        "ip":'',
        "urine":'',
        "uqty":'',
        "motion":'',
        "mqty":'',
        "ngqty":'',
        "out_time":'',
        "out_notes":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

   useEffect(() => {
        fetchdietinData();
        fetchdietoutData();
   }, []);
    function fetchdietinData() {
      axios.get(baseUrl + "view-diet-in/" + ip_id + "/")
        .then(response => {
          setViewDietinData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
    function fetchdietoutData() {
      axios.get(baseUrl + "view-diet-out/" + ip_id + "/")
        .then(response => {
          setViewDietoutData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const forminSubmit = (e) => {
      e.preventDefault();
         const blood = document.getElementById("blood").value;
         const bqty = document.getElementById("bqty").value;
         const fluid = document.getElementById("fluid").value;
         const fqty = document.getElementById("fqty").value;
         const ngqty = document.getElementById("ngqty").value;
         const oral = document.getElementById("oral").value;
         const oqty = document.getElementById("oqty").value;
         const in_time = document.getElementById("in_time").value;
         const in_notes = document.getElementById("in_notes").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('blood', blood);
          _formData.append('bqty', bqty);
          _formData.append('fluid', fluid);
          _formData.append('fqty', fqty);
          _formData.append('ngqty', ngqty);
          _formData.append('oral', oral);
          _formData.append('oqty', oqty);
          _formData.append('in_time', in_time);
          _formData.append('in_notes', in_notes);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}diet-in-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Diet Intake Created Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/nurse-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const formoutSubmit = (e) => {
      e.preventDefault();
         const urine = document.getElementById("urine").value;
         const uqty = document.getElementById("uqty").value;
         const motion = document.getElementById("motion").value;
         const mqty = document.getElementById("mqty").value;
         const ngqty = document.getElementById("ngaqty").value;
         const out_time = document.getElementById("out_time").value;
         const out_notes = document.getElementById("out_notes").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('urine', urine);
          _formData.append('uqty', uqty);
          _formData.append('motion', motion);
          _formData.append('mqty', mqty);
          _formData.append('ngqty', ngqty);
          _formData.append('out_time', out_time);
          _formData.append('out_notes', out_notes);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}diet-out-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Diet Output Created Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/nurse-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const handleinDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-diet-in/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/diet-detail/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
    const handleoutDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-diet-out/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/diet-detail/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
     <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
        </table>
     </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-apple-whole" aria-hidden="true" style={{ color: 'red' }}></i>
      Intake Details
    </h3>
      <form>
      <div className="row">
        <div className="col-md-2">
          <label htmlFor="Tempr" className="form-label">Blood : </label>
          <select className="form-control"
                name="blood" id="blood" >
                <option >Select</option>
                <option value="Whole Blood">Whole Blood</option>
                <option value="PC">PC</option>
                <option value="PRP">PRP</option>
                <option value="FFP">FFP</option>
                <option value="PRB">PRB</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="" className="form-label">Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="bqty"
            id="bqty"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Fluid" className="form-label">Fluid : </label>
          <select className="form-control"
                name="fluid" id="fluid" >
                <option >Select</option>
            <option value="NS">NS</option>
            <option value="DNS">DNS</option>
            <option value="RL">RL</option>
            <option value="ISO-M">ISO-M</option>
            <option value="3% Saline">3% Saline</option>
            <option value="Manital">Manital</option>
            <option value="Volevon">Volevon</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="fqty"
            id="fqty"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">NG Feed Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="ngqty"
            id="ngqty"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Oral : </label>
          <select className="form-control"
                name="oral" id="oral" >
            <option >Select</option>
            <option value="Water">Water</option>
            <option value="Tea">Tea</option>
            <option value="Kanji">Kanji</option>
            <option value="Soup">Soup</option>
            <option value="TC water">TC Water</option>
            <option value="Iuice">Juice</option>
            <option value="Milk">Milk</option>
            <option value="Coffee">Coffee</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="oqty"
            id="oqty"
          />
        </div>
        <div className="col-md-2 ms-1">
        <label htmlFor="Notes" className="form-label">Notes : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="in_notes"
          id="in_notes"
          ></textarea>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Diet Intake Time : </label>
          <DatePicker className="form-control" name="in_time" id="in_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5 mb-5' >
          <button type="button" onClick={forminSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
      <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-poo" aria-hidden="true" style={{ color: 'red' }}></i>
      Out Take Details
      </h3>
      <form>
      <div className="row">
        <div className="col-md-2">
          <label htmlFor="Tempr" className="form-label">Urine : </label>
          <select className="form-control"
                name="urine" id="urine" >
                <option >Select</option>
                <option value="Self Void">Self Void</option>
                <option value="Catheter">Catheter</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="" className="form-label">Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="uqty"
            id="uqty"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="" className="form-label">Motion : </label>
          <select className="form-control"
                name="motion" id="motion" >
                <option >Select</option>
            <option value="Normal">Normal</option>
            <option value="Loose Stool">Loose Stool</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Drain Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="mqty"
            id="mqty"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">NGT Aspiration Qty : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="ngaqty"
            id="ngaqty"
          />
        </div>

        <div className="col-md-2 ms-1">
        <label htmlFor="Notes" className="form-label">Notes : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="out_notes"
          id="out_notes"
          ></textarea>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Diet Output Time : </label>
          <DatePicker className="form-control" name="out_time" id="out_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formoutSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
              <div className="card card-body mt-5">
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-apple-whole" aria-hidden="true" style={{ color: 'red' }}></i>
                  Diet Intake History
                    </h3>
               <div className="table-responsive">
              <table className="erp-table-modern">
              <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                      <th>Date</th>
                      <th colSpan="7">Intake Details</th>
                      <th>Notes</th>
                      <th>Delete</th>
                    </tr>
              </thead>
              <tbody>
                {viewdietinData.map((din, index) => (
                      <tr >
                        <td>{formatDateTime(din.in_time)}</td>
                        <td>{din.blood}</td>
                        <td>{din.bqty}</td>
                        <td>{din.fluid}</td>
                        <td>{din.fqty}</td>
                        <td>{din.ngqty}</td>
                        <td>{din.oral}</td>
                        <td>{din.oqty}</td>
                        <td>{din.in_notes}</td>
                        <td>
                          <button className="btn btn-danger" type="button" onClick={() => handleinDelete(din.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                </table>
                </div>
              </div>
              <div className="card card-body mt-5">
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-poo" aria-hidden="true" style={{ color: 'red' }}></i>
                  Diet Out History
                    </h3>
               <div className="table-responsive">
              <table className="erp-table-modern">
              <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                      <th>Date</th>
                      <th colSpan="5">Output Details</th>
                      <th>Notes</th>
                      <th>Delete</th>
                    </tr>
              </thead>
              <tbody>
                {viewdietoutData.map((dout, index) => (
                      <tr >
                        <td>{formatDateTime(dout.out_time)}</td>
                        <td>{dout.urine}</td>
                        <td>{dout.uqty}</td>
                        <td>{dout.motion}</td>
                        <td>{dout.mqty}</td>
                        <td>{dout.ngqty}</td>
                        <td>{dout.out_notes}</td>
                        <td>
                          <button className="btn btn-danger" type="button" onClick={() => handleoutDelete(dout.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                </table>
              </div>
              </div>
    </div>
    </section>
    )
}

export default DietDetail;